export const validateEmail = (email: string) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const validateNumberRange = (input: string) => {
    const match = input.match(/\b\d+-\d+\b/g);
    let isValid = false;

    if (match && match.length === 1) {
        const splitedInput = input.split('-');
        (+splitedInput[0] < +splitedInput[1]) && (isValid = true)
    }

    return isValid;
};

export const validateGPA = (GPA: string) => {
    return GPA.match(/^[0-4]\.\d$/) && +GPA <= 4;
};

export const validateZipCode = (zipCode: string) => {
    return zipCode.match(/^\d{5}(?:[-\s]\d{4})?$/);
};

interface ObjectType {
    [key: string]: any;
}

export const objectToFormData = (obj: ObjectType): FormData => {
    const formData = new FormData();
    Object.keys(obj).forEach(key => formData.append(key, obj[key]));
    return formData;
}

export const objectURLToBlob = async (objectURL: string): Promise<Blob> => {
    let blob = await fetch(objectURL).then(r => r.blob());
    return blob;
};

export const toTime = (number: number) => {
    const minutes = Math.floor(number / 60);
    const sec = number - minutes * 60;
    const seconds = sec < 10 ? `0${sec}` : sec
    const hours = Math.floor(number / 3600);

    return {
        seconds,
        minutes,
        hours,
    };
};

interface SnippetMap {
    start: number;
    end: number;
    type: 'Text' | 'Code';
};

export const snippetFinder = (str: string) => {
    let startIndex = 0;
    const indices = [];
    let index;
    const map: SnippetMap[] = [];
    const mainElement = document.createElement('div');

    while ((index = str.indexOf('`', startIndex)) > -1) {
        indices.push(index);
        startIndex = index + 1;
    }

    if (!indices.length) {
        map.push({ start: 0, end: str.length, type: 'Text' })
    } else {


        if (indices[0] !== 0) {
            map.push({ start: 0, end: indices[0], type: 'Text' })


            // const firstPart = document.createElement('span');
            // firstPart.innerText = str.slice(0, indices[0]);
            // mainElement.appendChild(firstPart);
        }

        for (let i = 0; i < indices.length; i + 2) {
            map.push({ start: indices[i], end: indices[i + 1], type: 'Code' });
            if (indices[i + 2]) {
                map.push({ start: indices[i + 1], end: indices[i + 2], type: 'Text' });
            }



            // const snippet = str.slice(indices[i] + 1, indices[i + 1]);
            // const snippetElement = document.createElement('code');
            // snippetElement.innerText = snippet;
            // mainElement.appendChild(snippetElement);

            // const textElement = document.createElement('span');
            // textElement.innerText = str.slice(indices[i + 1], indices[i + 2]);
            // mainElement.appendChild(textElement);
        }
    }

    return map;
}

export const objectURLToFile = async (objectURL: string, fileName: string, type: string): Promise<File> => {
    let blob = await fetch(objectURL).then(r => r.blob());
    const file = new File([blob], fileName, { type });
    return file;
};

export const examStatusTitle = (status: string) => {
    switch (status) {
        case 'multipleChoiceExamRunning':
        case 'multipleChoiceExamReview':
        case 'multipleChoiceExam':
            return 'Multiple Choice'
        case 'interview':
            return 'Interview'
        case 'finalResult':
            return 'Final Result'
        case 'pending':
            return 'Pending';
        case 'codingExam':
        case 'codingExamRunning':
        case 'codingExamReview':
        case 'codingExamNotCompleted':
            return 'Coding'
        case 'closed':
            return 'Closed'
        case 'onPause':
            return 'On Pause'
        default:
            return ''
    }
};


export function isValidURL(url: string) {
    const pattern = /^(https?:\/\/)?([\w.-]+)+\.[a-z]{2,}(:\d+)?(\/[^\s]*)?$/i;
    return pattern.test(url);
};

export function isBusinessEmail(email: string) {
    if (!validateEmail(email)) {
        return false; // invalid email format
    }

    const freeEmailDomains = [
        // "gmail.com",
        "hi2.in",
        "yahoo.com",
        "hotmail.com",
        "outlook.com",
        "icloud.com",
        "aol.com",
        "protonmail.com",
        "gmx.com",
        "zoho.com",
        "mail.com",
        "yandex.com",
        "live.com"
    ];

    const domain = email.split("@")[1].toLowerCase();
    return !freeEmailDomains.includes(domain);
};

export const camelCaseToSpacedString = (status: string) => {
    return status.replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Handle consecutive capitals
        .toLowerCase() // Convert all to lowercase first
        .replace(/^./, str => str.toUpperCase()) // Capitalize only first letter
        .trim(); // Remove any extra spaces
};